var Filters_select = {
    init:function(){
        console.log("filters.init");

        $('.filters-select select').on("change", function(){
            $('#filters').submit();
        });
    }
}

$(window).load(function(){
    if($(".filters-select").length){
        Filters_select.init();
    }
})